import { callGuestAPI } from "../axios/guestAxios";

async function allTypes() {
  const options = {
    method: "GET",
    url: "/reservation/v1/get-all-types",
  };
  const res = await callGuestAPI(options);
  return res;
}

async function allFrequencies() {
  const options = {
    method: "GET",
    url: "/reservation/v1/get-all-frequencies",
  };
  const res = await callGuestAPI(options);
  return res;
}

async function allReservedDates() {
  const options = {
    method: "GET",
    url: "/reservation/v1/get-all-reserved-dates",
    params: {
      t: Date.now(),
    },
  };
  const res = await callGuestAPI(options);
  return res;
}

async function checkAvailability(
  date,
  toDate,
  recurringOption,
  frequencyOption
) {
  const options = {
    method: "GET",
    url: "/reservation/v1/check-recurring-availability",
    params: { date, toDate, recurringOption, frequencyOption },
  };
  const res = await callGuestAPI(options);
  return res;
}

const CalendarServices = {
  allTypes,
  allFrequencies,
  allReservedDates,
  checkAvailability,
};

export default CalendarServices;
